import { HttpClient } from "../../../../services/http/http-client";
import { MODIFICATION_URL } from "../../../../services/common-urls";
import { BOOKING_URL, BOOKINGS_STRING, CALENDAR_DATES_STRING } from "../booking-service";

const BOOKING_CAL_CUSTOM_CHECKLIST_FORM_STRING = 'booking_calendar_custom_checklist_form';
const ADD_NEW_STRING = 'add_new';
const DELETE_NAME_STRING = 'delete_name';
const EDIT_STRING = 'edit';
export const customChecklistService = {
    insertCustomChecklistItem: (
        calendarDateId,
        checklistItem
    ) => {
        return HttpClient.post(BOOKING_URL, {
            section: BOOKINGS_STRING,
            section_db: BOOKINGS_STRING,
            external_table: CALENDAR_DATES_STRING,
            external_id: calendarDateId,
            action: BOOKING_CAL_CUSTOM_CHECKLIST_FORM_STRING,
            action_perform: ADD_NEW_STRING,
            ccl_item_name_new: checklistItem,
        });
    },
    checkCustomChecklistItem: (
        calendarDateId,
        checklistItem
    ) => {
        return HttpClient.get2(BOOKING_URL, {
            section_db: BOOKINGS_STRING,
            external_table: CALENDAR_DATES_STRING,
            external_id: calendarDateId,
            action: BOOKING_CAL_CUSTOM_CHECKLIST_FORM_STRING,
            action_perform: ADD_NEW_STRING,
            section: BOOKINGS_STRING,
            ccl_item_name_new: checklistItem,
        });
    },
    uncheckCustomChecklistItem: (
        checklistId,
    ) => {
        return HttpClient.get2(BOOKING_URL, {
            checklist_id  : checklistId,
            section_db    : BOOKINGS_STRING,
            action        : BOOKING_CAL_CUSTOM_CHECKLIST_FORM_STRING,
            action_perform: DELETE_NAME_STRING,
            section       : BOOKINGS_STRING
        });
    },
    editCustomChecklistItemName: (
        oldName,
        newName
    ) => {
        return HttpClient.get2(BOOKING_URL, {
            action: BOOKING_CAL_CUSTOM_CHECKLIST_FORM_STRING,
            section: BOOKINGS_STRING,
            section_db: BOOKINGS_STRING,
            action_perform: EDIT_STRING,
            old_name: oldName,
            new_name: newName,
        });
    },
    removeCustomChecklistItem: (
        checkListName
    ) => {
        return HttpClient.get2(BOOKING_URL, {
            action: BOOKING_CAL_CUSTOM_CHECKLIST_FORM_STRING,
            section: BOOKINGS_STRING,
            section_db: BOOKINGS_STRING,
            action_perform: DELETE_NAME_STRING,
            checklist_name: checkListName,
        });
    }
};
